var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      {
        attrs: { novalidate: "true" },
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.save($event)
          }
        }
      },
      [
        _c("div", { staticClass: "modal-card" }, [
          _c("header", { staticClass: "modal-card-head" }, [
            _c("p", { staticClass: "modal-card-title" }, [
              _vm._v(_vm._s(_vm.isEdit ? "עריכת מפתח API" : "הוספת מפתח API"))
            ]),
            _c("button", {
              staticClass: "delete",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            })
          ]),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [
              _c(
                "b-field",
                { attrs: { label: "שם" } },
                [
                  _c("b-input", {
                    model: {
                      value: _vm.$v.model.Name.$model,
                      callback: function($$v) {
                        _vm.$set(_vm.$v.model.Name, "$model", $$v)
                      },
                      expression: "$v.model.Name.$model"
                    }
                  })
                ],
                1
              ),
              !_vm.$v.model.Name.required && _vm.$v.model.Name.$error
                ? _c("p", { staticClass: "error" }, [_vm._v("שדה חובה")])
                : _vm._e(),
              _c(
                "b-field",
                { attrs: { label: "מייל" } },
                [
                  _c("b-input", {
                    model: {
                      value: _vm.model.Email,
                      callback: function($$v) {
                        _vm.$set(_vm.model, "Email", $$v)
                      },
                      expression: "model.Email"
                    }
                  })
                ],
                1
              ),
              _c(
                "b-field",
                { attrs: { label: "אפליקציות" } },
                [
                  _c("b-loading", {
                    attrs: { "is-full-page": false },
                    model: {
                      value: _vm.isLoadingApps,
                      callback: function($$v) {
                        _vm.isLoadingApps = $$v
                      },
                      expression: "isLoadingApps"
                    }
                  }),
                  !_vm.isLoadingApps
                    ? _c(
                        "div",
                        { staticClass: "apps-checkboxes" },
                        [
                          _vm._l(_vm.apps, function(app) {
                            return _c(
                              "b-checkbox",
                              {
                                key: app.Id,
                                attrs: { "native-value": app.Id },
                                model: {
                                  value: _vm.selectedAppIds,
                                  callback: function($$v) {
                                    _vm.selectedAppIds = $$v
                                  },
                                  expression: "selectedAppIds"
                                }
                              },
                              [_vm._v(" " + _vm._s(app.Name) + " ")]
                            )
                          }),
                          !_vm.apps.length
                            ? _c("p", { staticClass: "has-text-grey" }, [
                                _vm._v("אין אפליקציות זמינות")
                              ])
                            : _vm._e()
                        ],
                        2
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm.appError
                ? _c("p", { staticClass: "error" }, [
                    _vm._v("יש לבחור לפחות אפליקציה אחת")
                  ])
                : _vm._e(),
              _vm.isEdit
                ? _c(
                    "b-field",
                    { attrs: { label: "פעיל" } },
                    [
                      _c(
                        "b-switch",
                        {
                          model: {
                            value: _vm.model.IsActive,
                            callback: function($$v) {
                              _vm.$set(_vm.model, "IsActive", $$v)
                            },
                            expression: "model.IsActive"
                          }
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.model.IsActive ? "כן" : "לא") + " "
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isEdit && _vm.createdKey
                ? _c(
                    "div",
                    { staticClass: "created-key-box" },
                    [
                      _c(
                        "b-field",
                        { attrs: { label: "API KEY" } },
                        [
                          _c("b-input", {
                            attrs: {
                              readonly: "",
                              type: "password",
                              value: _vm.createdKey.ApiKey,
                              "password-reveal": ""
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "b-field",
                        { attrs: { label: "SECRET KEY" } },
                        [
                          _c("b-input", {
                            attrs: {
                              readonly: "",
                              type: "password",
                              value: _vm.createdKey.ApiSecret,
                              "password-reveal": ""
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "footer",
            { staticClass: "modal-card-foot" },
            [
              _c("b-button", {
                attrs: {
                  "native-type": "submit",
                  loading: _vm.isSaving,
                  label: "שמור",
                  type: "is-primary"
                }
              }),
              _c("b-button", {
                attrs: { disabled: _vm.isSaving, label: "סגור" },
                on: {
                  click: function($event) {
                    return _vm.$emit("close")
                  }
                }
              })
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }